module.exports = __webpack_public_path__ + "img/electronic_enabled.b910f2df.svg";